import type { CarouselsType } from '@/types';
import { Carousel } from '@mantine/carousel';
import { AspectRatio, Image } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
export type CarouselImageItemProps = CarouselsType & {
  mobileWidth?: number;
  desktopWidth?: number;
};
export const CarouselImageItem: React.FC<CarouselImageItemProps> = ({
  id,
  imgCard,
  mobileWidth,
  desktopWidth
}) => {
  const isMobile = useMediaQuery('(max-width: 36em)');
  return <Carousel.Slide>
      <AspectRatio ratio={isMobile ? mobileWidth : desktopWidth}>
        <Image src={imgCard} radius="md" alt={`game-${id}`} />
      </AspectRatio>
    </Carousel.Slide>;
};